"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.repeat = void 0;
const foundation_1 = require("../foundation");
exports.repeat = {
    repeat: {
        ids_repeat_general_none: foundation_1.foundation_repeat.repeat.repeat_none,
        ids_repeat_general_1x: foundation_1.foundation_repeat.repeat.repeat_1,
        ids_repeat_general_2x: foundation_1.foundation_repeat.repeat.repeat_2,
        ids_repeat_general_4x: foundation_1.foundation_repeat.repeat.repeat_4,
        ids_repeat_general_8x: foundation_1.foundation_repeat.repeat.repeat_8,
        ids_repeat_general_infinite: foundation_1.foundation_repeat.repeat.repeat_infinite,
    }
};
//# sourceMappingURL=repeat.js.map